/*
 * INTEX CUSTOM — not part of vanilla Ignite. See INTEX-CHANGES.md §14.90.
 *
 * Keeps a tall sticky panel fully reachable. From 990px the panel column
 * beside the products is position: sticky (assets/intex-model-select.css,
 * "Responsive layout"). A panel taller than the screen used to stick by its
 * top, so its lower part stayed below the fold until the end of the product
 * list. This publishes the column's height as --intex-aside-h, and the CSS
 * uses it to stick a tall column by its bottom instead: it scrolls with the
 * page until its last block is in view, then stays put. A short column sticks
 * under the header as before.
 *
 * Measurement only — no layout is decided here. Without this script the
 * variable is unset and the column sticks by its top, as it always did.
 */
(() => {
  const SELECTOR = '.intex-mc__aside, .intex-select__aside';

  if (!('ResizeObserver' in window)) return;

  const observer = new ResizeObserver((entries) => {
    for (const entry of entries) {
      entry.target.style.setProperty('--intex-aside-h', `${entry.target.offsetHeight}px`);
    }
  });

  const watch = (root) => {
    root.querySelectorAll(SELECTOR).forEach((aside) => observer.observe(aside));
  };

  watch(document);

  /* The theme editor re-renders a section in place, with new elements. */
  document.addEventListener('shopify:section:load', (event) => watch(event.target));
})();